import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withId = /*#__PURE__*/_withScopeId("data-v-cf51e862");

_pushScopeId("data-v-cf51e862");

var _hoisted_1 = {
  key: 0
};

var _hoisted_2 = /*#__PURE__*/_createVNode("i", {
  class: "iconfont icon-bug-report"
}, null, -1
/* HOISTED */
);

var _hoisted_3 = /*#__PURE__*/_createVNode("span", {
  style: {
    "padding-right": "10px"
  }
}, "Error Log", -1
/* HOISTED */
);

var _hoisted_4 = /*#__PURE__*/_createTextVNode("Clear All");

var _hoisted_5 = /*#__PURE__*/_createVNode("span", {
  class: "message-title"
}, "Msg:", -1
/* HOISTED */
);

var _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1
/* HOISTED */
);

var _hoisted_7 = /*#__PURE__*/_createVNode("span", {
  class: "message-title",
  style: {
    "padding-right": "10px"
  }
}, "Info: ", -1
/* HOISTED */
);

var _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1
/* HOISTED */
);

var _hoisted_9 = /*#__PURE__*/_createVNode("span", {
  class: "message-title",
  style: {
    "padding-right": "16px"
  }
}, "Url: ", -1
/* HOISTED */
);

_popScopeId();

export var render = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_el_badge = _resolveComponent("el-badge");

  var _component_el_tag = _resolveComponent("el-tag");

  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_table = _resolveComponent("el-table");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return $options.errorLogs.length > 0 ? (_openBlock(), _createBlock("div", _hoisted_1, [_createVNode(_component_el_badge, {
    "is-dot": true,
    style: {
      "line-height": "25px",
      "margin-top": "-5px"
    },
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $data.dialogTableVisible = true;
    })
  }, {
    default: _withId(function () {
      return [_createVNode(_component_el_button, {
        style: {
          "padding": "8px 10px"
        },
        size: "small",
        type: "danger"
      }, {
        default: _withId(function () {
          return [_hoisted_2];
        }),
        _: 1
        /* STABLE */

      })];
    }),
    _: 1
    /* STABLE */

  }), _createVNode(_component_el_dialog, {
    "close-on-click-modal": false,
    modelValue: $data.dialogTableVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.dialogTableVisible = $event;
    }),
    width: "80%",
    "append-to-body": ""
  }, {
    title: _withId(function () {
      return [_hoisted_3, _createVNode(_component_el_button, {
        size: "mini",
        type: "primary",
        icon: "el-icon-delete",
        onClick: $options.clearAll
      }, {
        default: _withId(function () {
          return [_hoisted_4];
        }),
        _: 1
        /* STABLE */

      }, 8
      /* PROPS */
      , ["onClick"])];
    }),
    default: _withId(function () {
      return [_createVNode(_component_el_table, {
        data: $options.errorLogs,
        border: ""
      }, {
        default: _withId(function () {
          return [_createVNode(_component_el_table_column, {
            label: "Message"
          }, {
            default: _withId(function (_ref) {
              var row = _ref.row;
              return [_createVNode("div", null, [_hoisted_5, _createVNode(_component_el_tag, {
                type: "danger"
              }, {
                default: _withId(function () {
                  return [_createTextVNode(_toDisplayString(row.err.message), 1
                  /* TEXT */
                  )];
                }),
                _: 2
                /* DYNAMIC */

              }, 1024
              /* DYNAMIC_SLOTS */
              )]), _hoisted_6, _createVNode("div", null, [_hoisted_7, _createVNode(_component_el_tag, {
                type: "warning"
              }, {
                default: _withId(function () {
                  return [_createTextVNode(_toDisplayString(row.vm.$vnode.tag) + " error in " + _toDisplayString(row.info), 1
                  /* TEXT */
                  )];
                }),
                _: 2
                /* DYNAMIC */

              }, 1024
              /* DYNAMIC_SLOTS */
              )]), _hoisted_8, _createVNode("div", null, [_hoisted_9, _createVNode(_component_el_tag, {
                type: "success"
              }, {
                default: _withId(function () {
                  return [_createTextVNode(_toDisplayString(row.url), 1
                  /* TEXT */
                  )];
                }),
                _: 2
                /* DYNAMIC */

              }, 1024
              /* DYNAMIC_SLOTS */
              )])];
            }),
            _: 1
            /* STABLE */

          }), _createVNode(_component_el_table_column, {
            label: "Stack"
          }, {
            default: _withId(function (_ref2) {
              var row = _ref2.row;
              return [_createTextVNode(_toDisplayString(row.err.stack), 1
              /* TEXT */
              )];
            }),
            _: 1
            /* STABLE */

          })];
        }),
        _: 1
        /* STABLE */

      }, 8
      /* PROPS */
      , ["data"])];
    }),
    _: 1
    /* STABLE */

  }, 8
  /* PROPS */
  , ["modelValue"])])) : _createCommentVNode("v-if", true);
});